import React from "react";
import "./AboutContent.css";

function Content2026() {
  return (
    <>
      <section className="hero">
        <div className="heading">
          <h1>Productions</h1>
          <h3>
            <a href="/productions">Current Productions</a> -{" "}
            <a href="/2024productions">2024</a> -{" "}
            <a href="/2025productions">2025</a> -{" "}
            <a href="/2026productions">2026</a>
          </h3>
        </div>
      </section>

      <br></br>

      <div className="container reverse-order">
        <div className="hero-image-left">
          <img src="images/setinchicago4.jpg" alt="littlehelp" />
        </div>
        <div className="hero-content">
          <h2>Set in Chicago</h2>
          <h3>Movie Sequels Improv Comedy</h3>
          <h4>de Maat Studio Theater @ Second City</h4>
        </div>
      </div>

      <br></br>
      <div className="container">
        <div className="hero-content">
          <h2>New Week New Show</h2>
          <h3>Sketch Comedy</h3>
          <h4>de Maat Studio Theater @ Second City</h4>
        </div>
        <div className="hero-image-left">
          <img src="images/newshow.jpg" alt="kittyandkellie" />
        </div>
      </div>
      <br></br>

      <div className="container reverse-order">
        <div className="hero-image-left">
          <img src="images/setinchicago3.jpg" alt="littlehelp" />
        </div>
        <div className="hero-content">
          <h2>Set in Chicago</h2>
          <h3>Movie Sequels Improv Comedy</h3>
          <h4>de Maat Studio Theater @ Second City</h4>
        </div>
      </div>

      <br></br>
      <div className="container">
        <div className="hero-content">
          <h2>The Kitty & Kellie Show</h2>
          <h3>Improv/Sketch Comedy</h3>
          <h4>de Maat Studio Theater @ Second City</h4>
        </div>
        <div className="hero-image-left">
          <img src="images/kittyandkellie2.png" alt="kittyandkellie" />
        </div>
      </div>

      <br></br>
      <div className="container reverse-order">
        <div className="hero-image-left">
          <img src="images/provelove3.jpg" alt="littlehelp" />
        </div>
        <div className="hero-content">
          <h2>Prov Ur Love 2 Me</h2>
          <h3>Improv Comedy</h3>
          <h4>de Maat Studio Theater @ Second City</h4>
        </div>
      </div>

      <br></br>

      <div className="container">
        <div className="hero-content">
          <h2>New Year, New Show</h2>
          <h3>Sketch Comedy</h3>
          <h4>de Maat Studio Theater @ Second City</h4>
        </div>
        <div className="hero-image-left">
          <img src="images/newyear.jpg" alt="history" />
        </div>
      </div>
    </>
  );
}

export default Content2026;
